























































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { TypeCreneau, UpdateTypeCreneauModel } from "@/api/models/typesCreneau/typeCreneau";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "update-type-creneau",
})
export default class EditTypeCreneau extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateTypeCreneauSidebarActive!: boolean;
  @Prop({ required: true }) typeCreneauId!: string;

  loading = false;
  required = required;
  loadingTypeCreneau = false;



  typeCreneau: UpdateTypeCreneauModel = {};

  async created() {
    this.loadingTypeCreneau = true
    await this.$http.myressif.typesCreneau
      .getById(this.typeCreneauId)
      .then((res: TypeCreneau) => {
        this.typeCreneau = res;
        this.loadingTypeCreneau = false;
      });
  }

  resetForm() {
    this.typeCreneau = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.typesCreneau
      .update(
        this.typeCreneauId,
        this.typeCreneau
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification du type de créneau",
            text: "Type de créneau modifié avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-types-creneau");
        this.$emit("update:is-update-type-creneau-sidebar-active", false);
        this.loading = false;
      });
  }
}
